import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Config } from '../../config/config';

@Injectable({
  providedIn: 'root'
})
export class ActFijoService {

  dataUrl = Config.URL_BASE;
  constructor(private http: HttpClient) {
  }

  getConteoActivosDepreciados(emp: number, periodo: number) {
    let url_ = this.dataUrl + '/activo-fijo/get/activos/no/depr/' + emp + '/' + periodo;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get( url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  getSimulacionXls(dto: any) {
    let url_ = this.dataUrl + '/activo-fijo/post/simular';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post( url_, dto, {responseType: 'blob'}).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  getDatosCierre(id: number): Observable<any> {
    let url_ = this.dataUrl + '/ctbConfEmp/get/periodo/cierre/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  post(dto: any, idUsr: number): Observable<any> {
    let url_ = this.dataUrl + '/activo-fijo/post/' + idUsr;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  postDepreciacion(dto: any): Observable<any> {
    let url_ = this.dataUrl + '/activo-fijo/post/depreciar';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  put(dto: any, idUsr: number): Observable<any> {
    let url_ = this.dataUrl + '/activo-fijo/put/' + idUsr;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.put(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  ctaCatalogo(criterio: any): Observable<any> {
    let url_ = this.dataUrl + '/cta/catalogo';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, criterio).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  delete(id: number, idUsr: number): Observable<any> {
    const url_ = this.dataUrl + '/activo-fijo/delete/' + id + '/' + idUsr;
    return this.http.delete(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  get(id: number): Observable<any> {
    let url_ = this.dataUrl + '/activo-fijo/get/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  catalogo(criterio: any): Observable<any> {
    let url_ = this.dataUrl + '/activo-fijo/catalogo';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, criterio).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
}
